import { render, staticRenderFns } from "./TemperatureRecords.vue?vue&type=template&id=9f423c5a&scoped=true"
import script from "./TemperatureRecords.vue?vue&type=script&lang=js"
export * from "./TemperatureRecords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f423c5a",
  null
  
)

export default component.exports